const autoNgTemplateLoaderTemplate1 = require('./informationPanelOffline.html');

angular.module('shbdeployer.app').component('informationPanelOffline', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'InformationPanelOfflineController',
});
